Vue.directive('ajax', {
	bind: function (el, binding, vnode) {
		el.addEventListener(
			'submit', function(e){
				e.preventDefault();

				var button = document.getElementById('submit');
				button.disabled = true;
				var resetForm = true;
				var formData = new FormData(el);

				var formInstance = el;
				var method = el.method.toLowerCase();

				Vue.http[method](el.action, formData)
					.then(function(response){

						if(response.data.success && resetForm)
						{
							formInstance.reset();

							el.style.display = 'none';
							document.getElementsByClassName('success')[0].style.display = 'block';

						} else{
							// à enlever
							el.style.display = 'none';
							document.getElementsByClassName('success')[0].style.display = 'block';
							//

							// à décommenter
							//document.getElementsByClassName('form-fail')[0].style.display = 'block';
						}

						button.disabled = false;
					})
			}
		);
	}
});
